import React, {useState, useRef, useEffect} from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { 
    Flex, VStack, Box, Center, Heading, Button, Text, Icon, Image, Link, CircularProgress, CircularProgressLabel, useToast
} from '@chakra-ui/react';
import moment from 'moment';
import axios from "axios";
import {faker} from '@faker-js/faker';
import { MdCheckCircle, MdError } from 'react-icons/md';
import { 
    API_SUB_URL_PATIENT, API_SUB_URL_SCHEDULE_MEDICAL, PRICING_LIST, 
    PENDING_STATUS, PAID_STATUS, SUCCESS_STATUS, FAILED_STATUS, PROCESSING_STATUS,
    REGISTER_COMPANY, EXTEND_COMPANY, MAKE_DOCTOR_APPOINTMENT, ERROR_CODES 
} from "../../../constants"
import _404Page from '../../../components/404Page';
const PAYMENT_FAILED_TEXT =  "Quá trình thanh toán không thành công. Quý khách vui lòng thử lại hoặc liên hệ với phòng khám để được hỗ trợ.";

function PaymentResponse() {
    const [ cookies, setCookie, removeCookie ] = useCookies(["makeDoctorAppointmentDatas"]);
    const mounted = useRef();
    const { search } = useLocation();
    const [ paymentResponseText, setPaymentResponseText ] = useState(null);
    const [ notFoundResult, setNotFoundResult ] = useState(false);
    const [ isProcessing, setIsProcessing ] = useState(false);

    const toast = useToast();
    const navigate = useNavigate();
    const query = new URLSearchParams(search);
    const ORDER_CODE = query.get("orderCode");
    const { payment_type, payment_status } = useParams();

    useEffect(() => {
        if(!mounted.current) {
            if(!payment_type || !payment_status || !(payment_status && (payment_status.toUpperCase() === SUCCESS_STATUS) || (payment_status.toUpperCase() === FAILED_STATUS))) {
                setNotFoundResult(true);
            }

            if(payment_status.toUpperCase() !== SUCCESS_STATUS) {
                setPaymentResponseText(PAYMENT_FAILED_TEXT);
                handleFailedPayment();
                return;
            }

            if(payment_type === REGISTER_COMPANY) {
                handleRegisterCompanyPayment();
            } else if(payment_type === EXTEND_COMPANY) {
                handleExtendCompanyPayment();
            } else if(payment_type === MAKE_DOCTOR_APPOINTMENT) {
                handleMakeDoctorAppointmentPayment();
            } else {
                setNotFoundResult(true);
            }
            
            mounted.current = true;
        }
    });

    const handleRegisterCompanyPayment = async() => {
        setIsProcessing(true);

        try
        {
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/payments?order_code=${ORDER_CODE}`, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            const result = res.data.result;

            if(result && result.length > 0) {
                const { id, company_id, status, extra_data: { name, email, register_type, register_code } } = result[0];
                
                if(status === PENDING_STATUS) {
                    const updateCompanyRes = await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}/companies/${company_id}`, {
                        is_active: true
                    }, {
                        auth: {
                            username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                            password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                        }
                    });

                    if(updateCompanyRes.data?.status === 200) {
                        await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/emails/new-register-company`, {
                            companyName: name,
                            companyEmail: email,
                            register_code,
                        }, {
                            auth: {
                                username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                                password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                            }
                        });

                        // update payment status
                        await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}/payments/${id}`, {
                            company_id: updateCompanyRes.data?.data?.id,
                            status: PAID_STATUS
                        }, {
                            auth: {
                                username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                                password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                            }
                        });

                        setPaymentResponseText(`
                            Quý khách đã đăng ký gói <span style="color: orange; font-weight: bold">${PRICING_LIST[register_type]?.label}</span> thành công. 
                            Tiếp tục truy cập vào <a href="/create_new_user/${register_code}" style="text-decoration: underline; color: green">Tạo tài khoản</a> để tạo tài khoản mới.    
                        `);
                    } else {
                        setPaymentResponseText(`
                            Quý khách đã đăng ký gói <span style="color: orange; font-weight: bold">${PRICING_LIST[register_type]?.label}</span> không thành công. 
                            Vui lòng liên hệ với phòng khám để được hỗ trợ.    
                        `);
                    }
                    setIsProcessing(false);
                } else {
                    setNotFoundResult(true);
                }
            } else {
                setNotFoundResult(true);
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    const handleExtendCompanyPayment = async() => {
        setIsProcessing(true);

        try
        {
            const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/payments?orderCode=${ORDER_CODE}`, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            const result = res.data.result;

            if(result && result.length > 0) {
                const { id, company_id, status, extra_data: { name, email, active_expired, register_type } } = result[0];
                
                if(status === PENDING_STATUS) {
                    const TOTAL_MONTH_ACTIVED = PRICING_LIST[register_type]?.total_month_actived; 
                    const MAX_USER_REGISTER = PRICING_LIST[register_type]?.max_user_register;
            
                    const updateCompanyRes = await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}/companies/${company_id}`, {
                        register_type,
                        active_expired: moment(new Date() >= active_expired ? new Date() : active_expired).add(TOTAL_MONTH_ACTIVED, "month").toDate(),
                        max_user_register: MAX_USER_REGISTER
                    }, {
                        auth: {
                            username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                            password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                        }
                    });
            
                    if(updateCompanyRes.data?.status === 200) {
                        await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/emails/extend-company`, {
                            companyName: name,
                            companyEmail: email,
                            pricingType: PRICING_LIST[register_type]?.label,
                            dueDate: moment(new Date() >= active_expired ? new Date() : active_expired).add(TOTAL_MONTH_ACTIVED, "month").toDate()
                        }, {
                            auth: {
                                username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                                password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                            }
                        });
                        
                        // update payment status
                        await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}/payments/${id}`, {
                            status: PAID_STATUS
                        }, {
                            auth: {
                                username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                                password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                            }
                        });

                        setPaymentResponseText(`
                            Quý khách đã gia hạn gói <span style="color: orange; font-weight: bold">${PRICING_LIST[register_type]?.label}</span> thành công. 
                            Quý khách đăng nhập phần mềm để tiếp tục sử dụng.    
                        `);
                    } else {
                        setPaymentResponseText(`
                            Quý khách đã gia hạn gói <span style="color: orange; font-weight: bold">${PRICING_LIST[register_type]?.label}</span> không thành công. 
                            Vui lòng liên hệ với phòng khám để được hỗ trợ.    
                        `);
                    }
                    setIsProcessing(false);
                } else {
                    setNotFoundResult(true);
                }
            } else {
                setNotFoundResult(true);
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    const handleMakeDoctorAppointmentPayment = async() => {
        setIsProcessing(true);

        try
        {
            const getPaymentRes = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/payments?order_code=${ORDER_CODE}`, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            const result = getPaymentRes.data?.result;
            
            if(result && result.length > 0) {
                if(result[0]?.status === PENDING_STATUS) {
                    const { 
                        isNewRegister, company_id, scheduleNumber, scheduleDate, selectedMedicalTime, reasonNeedDoctor, 
                        patientDetail, departmentDetail, doctorDetail, servicePriceDetail
                    } = cookies.makeDoctorAppointmentDatas?.data || {};
            
                    let patient_id;
            
                    if(isNewRegister) {
                        const createNewPatientRes = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}${API_SUB_URL_PATIENT}`, {
                            company_id: cookies.selectedClinic?.data?.id,
                            ...patientDetail
                        }, {
                            auth: {
                                username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                                password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                            }
                        });
            
                        patient_id = createNewPatientRes.data?.data?.id;
                    } else {
                        patient_id = patientDetail.id;
                    }
            
                    const createNewScheduleMedicalRes = await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}${API_SUB_URL_SCHEDULE_MEDICAL}`, {
                        company_id,
                        patient_id,
                        schedule_number: scheduleNumber,
                        department_id: departmentDetail.id,
                        doctor_id: doctorDetail.id,
                        day_schedule: scheduleDate,
                        time_schedule: selectedMedicalTime,
                        description: reasonNeedDoctor,
                        service_prices: servicePriceDetail,
                        status: PROCESSING_STATUS
                    }, {
                        auth: {
                            username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                            password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                        }
                    });
                    
                    if(createNewScheduleMedicalRes.data?.data?.id) {
                        // send email
                        axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/emails/send-confirm-schedule-medical`, {
                            schedule_medical_id: createNewScheduleMedicalRes.data?.data?.id,
                        }, {
                            auth: {
                                username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                                password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                            }
                        });
                    }
        
                    if(createNewScheduleMedicalRes.data?.status === 200) {
                        // update payment status
                        await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}/payments/${result[0].id}`, {
                            company_id,
                            status: PAID_STATUS
                        }, {
                            auth: {
                                username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                                password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                            }
                        });

                        setCookie("makeDoctorAppointmentDatas", 
                            { 
                                data: null
                            }, 
                            { path: '/', maxAge: 2400 }
                        );

                        setPaymentResponseText(`
                            Bạn đã đăng ký khám thành công với mã số <span style="color: orange; font-weight: bold">${scheduleNumber}</span>!
                            Vào <a href="/view_schedule" style="text-decoration: underline; color: green">Lịch khám</a> để xem thêm thông tin.
                        `);
                    } else {
                        setPaymentResponseText(`
                            Bạn đã đăng ký khám không thành công! Vui lòng thử lại! Vui lòng liên hệ với phòng khám để được hỗ trợ.
                        `);
                    }
                    setIsProcessing(false);
                } else {
                    setNotFoundResult(true);
                }
            } else {
                setNotFoundResult(true);
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    const handleFailedPayment = async() => {
        try
        {
            const getPaymentRes = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/payments?order_code=${ORDER_CODE}`, {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            });

            const result = getPaymentRes.data?.result;
            
            if(result && result.length > 0) {
                if(result[0]?.status === PENDING_STATUS) {
                    // update payment status
                    await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}/payments/${result[0].id}`, {
                        status: FAILED_STATUS
                    }, {
                        auth: {
                            username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                            password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                        }
                    });
                } else {
                    setNotFoundResult(true);
                }
            } else {
                setNotFoundResult(true);
            }
        }
        catch(error) {
            if(error?.code) {
                toast({
                    description: `${ERROR_CODES[error?.code]} (${error?.code})`,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "bottom-right"
                });
            }
        }
    }

    if(notFoundResult) {
        return (
            <_404Page />
        )
    }

    return (
        <VStack justifyContent="center">
            <Flex align="flex-end" gap={2}>
                <Image mt="2vh" alt="logo" src="/images/moc_tra_soft_logo.png" />
                <Link href='/' _hover={{ textDecoration: "none" }}>
                    <Text fontSize="30px" fontWeight="700" color="green.500">MỘC TRÀ SOFT</Text>
                </Link>
            </Flex>

            <Flex flexDirection="column" alignItems="center" justifyContent="center" 
                backgroundColor="rgba(247, 248, 251, 1)" p={4} w={{ base: "100vw", md: "70vw", lg: "70vw" }} borderRadius={8}
            >
                {
                    (payment_status.toUpperCase() === SUCCESS_STATUS) &&
                    <React.Fragment>
                        <Icon boxSize={24} as={MdCheckCircle} color="green.500" /> 
                        <Heading color="green.500">Thanh toán thành công</Heading>
                        <Box fontSize="18px" mt={4} dangerouslySetInnerHTML={{ __html: paymentResponseText }} />
                    </React.Fragment>
                }
                {
                    (payment_status.toUpperCase() === FAILED_STATUS) && 
                    <React.Fragment>
                        <Icon boxSize={24} as={MdError} color="red.500" /> 
                        <Heading color="red.500">Thanh toán không thành công</Heading>
                        <Text fontSize="18px" mt={4}>
                            {paymentResponseText}
                        </Text>
                    </React.Fragment>
                }
                {
                    isProcessing &&
                    <Center>
                        <CircularProgress isIndeterminate size="200px" zIndex={9999}>
                            <CircularProgressLabel fontSize="24px" fontWeight="700" color="#2196f3">Đang xử lý ...</CircularProgressLabel>
                        </CircularProgress>
                    </Center>
                }
                <Button mt={8} borderRadius={10} colorScheme='green' width={48} height={16}
                    onClick={() =>  {
                        navigate('/');
                    }}
                >
                    <Text fontSize="24px" fontWeight="800">TRANG CHỦ</Text>
                </Button>
            </Flex>
        </VStack>
    )
}

export default PaymentResponse;